module.exports = __webpack_public_path__ + "img/icon.0dca8c24.png";